<template>
    <div class="row">
        <config-menu></config-menu>
        <div class="col-md-10 pt-3" v-if="hasAnyRole('ROLE_ADMIN')">
            <button v-if="!edit" class="btn btn-outline-info btn-sm m-1" @click="onEdit"><i class="fa fa-edit"></i>編集</button>
            <form @submit.prevent="submit">
                <table class="table table-bordered">
                    <thead class="thead-light">
                    <tr>
                        <th>名称</th>
                        <th>設定値</th>
                        <th>説明</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr >
                            <td>メール通知</td>
                            <td>
                                <span v-if="!edit">{{config.emailEnable}}</span>
                                <input type="number" v-else v-model="config.emailEnable" min="0" max="1"/>
                            </td>
                            <td>0: 送信しない、1: 送信する</td>
                        </tr>
                        <tr v-if="config.emailEnable == 1">
                            <td>勤務表ファイルアップロード時のメール通知</td>
                            <td>
                                <span v-if="!edit">{{config.emailTimetableUploadEnable}}</span>
                                <input type="number" v-else v-model="config.emailTimetableUploadEnable" min="0" max="1"/>
                            </td>
                            <td>0: 送信しない、1: 送信する<span class="text-danger"></span></td>
                        </tr>
                        <tr>
                            <td>メール送信先</td>
                            <td>
                                <span v-if="!edit">{{config.emailTo}}</span>
                                <input type="text" v-else v-model="config.emailTo"/>
                            </td>
                            <td>カンマ区切りで指定可</td>
                        </tr>
                        <tr>
                            <td>デフォルト労働時間単位</td>
                            <td>
                                <span v-if="!edit">{{config.defaultWorkTimeInterval}}</span>
                                <input type="number" v-else v-model="config.defaultWorkTimeInterval" min="0" max="60"/>
                            </td>
                            <td>例） 0、15、30、60</td>
                        </tr>
                        <tr>
                            <td>デフォルト労働開始日</td>
                            <td>
                                <span v-if="!edit">{{config.defaultWorkStartDate}}</span>
                                <input type="number" v-else v-model="config.defaultWorkStartDate" min="0" max="28"/>
                            </td>
                            <td>例）15日締めの場合、16を設定。デフォルトは1</td>
                        </tr>
                    </tbody>
                </table>
                <button type="button" v-if="edit" class="btn btn-secondary" @click="onCancel">キャンセル</button>
                <button type="submit" v-if="edit" class="btn btn-primary">確定</button>
            </form>
        </div>
        <p v-else>閲覧権限がありません</p>
    </div>
</template>

<style scoped>
</style>

<script>
import CommonAPI from "../../../api/common-api.js";
import ConfigAPI from "../../../api/config-api.js";
import ConfigMenu from "./ConfigMenu.vue";

export default {
  name: "config",
  components: {
    ConfigMenu,
  },
  data() {
    return {
      edit: false,
      loginUser: {
          role: ''
      },
      config: {}
    }
  },
  watch: {
    '$root.$refs.asnHeader.$data.loginUser': function (val) {
      this.loginUser = val
    },
  },
  mounted () {
    this.getConfig()
  },
  methods: {
    // 設定取得
    getConfig () {
      this.$root.$refs.loading.$data.show = true
      ConfigAPI.get()
          .then(res => {
            this.config = res
            this.$nextTick(function() {
              $(".close").click()
              this.$root.$refs.loading.$data.show = false
            })
          })
          .catch(err => {
            console.error(err)
            this.$root.$refs.loading.$data.show = false
          })
    },
    // 権限を持っているか判定
    hasAnyRole: function (...args) {
        for (var i = 0; i < arguments.length; i++) {
            if (this.loginUser.role.includes(arguments[i])) {
                return true
            }
        }
        return false
    },
    onCancel () {
        this.edit = false
    },
    onEdit () {
        this.edit = true
    },
    // 更新
    submit () {
        this.$root.$refs.loading.$data.show = true
        ConfigAPI.update(this.config)
          .then(res => {
            this.edit = false
            this.getConfig()
          })
          .catch(err => {
            console.error(err)
            this.$root.$refs.loading.$data.show = false
          })
    }
  },
  filters: {
    settingEmpty: function (data) {
      return data ? data : '設定なし'
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/admin/config/Config.vue